<template>
  <validation-form @on-submit="submitForm">
    <div class="personal-information">
      <!-- MAIN_INFO -->
      <md-card class="card-content">
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title text-lg">
              {{ $t("grade_scale.grade_scale_info") }}
            </h4>
          </div>
        </md-card-header>

        <md-card-content>
          <div class="md-layout">
            <!-- Grade scale name -->
            <div class="md-layout-item md-size-33 md-small-size-100">
              <validation-field
                :validations="gradeScaleValidations.name"
                name="Grade scale name"
              >
                <label>{{ $t("grade_scale.name") }}</label>
                <md-input
                  :readonly="isReadOnly"
                  v-model.trim="form.name"
                  required
                ></md-input>
              </validation-field>
            </div>
            <!-- Grade scale name -->

            <!-- Description -->
            <div class="md-layout-item md-size-33 md-small-size-100">
              <md-field>
                <label>{{ $t("common.description") }}</label>
                <md-input
                  :readonly="isReadOnly"
                  v-model.trim="form.description"
                ></md-input>
              </md-field>
            </div>
            <!-- Description -->

            <!-- Set minimum score to pass -->
            <div class="md-layout-item md-size-33 md-small-size-100">
              <validation-field
                :validations="gradeScaleValidations.score"
                name="Grade scale score"
              >
                <label>{{ $t("grade_scale.set_minimum_score") }}</label>
                <md-input
                  :readonly="isReadOnly"
                  v-model.trim="form.scoreToPass"
                  min="0"
                ></md-input>
              </validation-field>
            </div>
            <!-- Set minimum score to pass -->

            <!-- Calculate GPA -->
            <div class="md-layout-item md-size-33 md-small-size-100">
              <md-checkbox
                :disabled="isReadOnly"
                v-model="form.isCalculateGpa"
                >{{ $t("grade_scale.calculate_gpa") }}</md-checkbox
              >
            </div>
            <!-- Calculate GPA -->

            <!-- Extra points for honor subject  -->
            <div class="md-layout-item md-size-33 md-small-size-100">
              <validation-field
                :validations="gradeScaleValidations.extraPointHonor"
                name="Grade scale honor"
              >
                <label>{{ $t("grade_scale.extra_point_honor") }}</label>
                <md-input
                  :readonly="isReadOnly"
                  v-model.trim="form.extraPointHonor"
                  min="0"
                ></md-input>
              </validation-field>
            </div>
            <!-- Extra points for honor subject  -->

            <!-- Extra points for advanced subject -->
            <div class="md-layout-item md-size-33 md-small-size-100">
              <validation-field
                :validations="gradeScaleValidations.extraPointAdvanced"
                name="Grade scale advanced"
              >
                <label>{{ $t("grade_scale.extra_point_advanced") }}</label>
                <md-input
                  :readonly="isReadOnly"
                  v-model.trim="form.extraPointAdvanced"
                  min="0"
                ></md-input>
              </validation-field>
            </div>
            <!-- Extra points for advanced subject -->
          </div>

          <!-- Grade letter -->
          <div
            class="md-layout-item md-size-100 mt-8 mb-2"
            v-if="form.gradeLetters.length > 0"
          >
            <h6 class="title text-lg font-medium normal-case">
              {{ $t("grade_scale.grade_letter") }}
            </h6>
          </div>

          <!-- header grade letter -->
          <div class="md-layout" v-if="form.gradeLetters.length > 0">
            <div class="md-layout-item md-size-15" />
            <div
              class="md-layout-item text-lg flex justify-center"
              :class="gradeScaleClass"
            >
              <div class="md-layout">
                <div class="md-layout-item md-size-45 flex justify-center">
                  {{ $t("grade_scale.grade_letter") }}
                </div>
                <div class="md-layout-item md-size-10"></div>
                <div class="md-layout-item md-size-45 flex justify-center">
                  {{ $t("grade_scale.score") }}
                </div>
              </div>
            </div>
            <div
              class="md-layout-item md-size-20 text-lg flex justify-center"
              v-if="form.isCalculateGpa"
            >
              {{ $t("grade_scale.gpa_value") }}
            </div>
          </div>
          <!-- header grade letter -->

          <!-- list form grade letter -->
          <div v-for="(item, index) in form.gradeLetters" :key="index">
            <div class="md-layout">
              <div
                class="
                  md-layout-item md-size-15
                  flex
                  items-end
                  mb-3.5
                  text-base
                "
              >
                {{ $t("grade_scale.grade_letter") }} {{ index + 1 }}
              </div>
              <div class="md-layout-item" :class="gradeScaleClass">
                <div class="md-layout">
                  <div class="md-layout-item md-size-45">
                    <validation-field
                      :validations="
                        generateValidation(
                          form.gradeLetters[index],
                          'gradeScale'
                        )
                      "
                      :name="'Grade letter ' + (index + 1)"
                    >
                      <md-input
                        :readonly="isReadOnly"
                        v-model.trim="form.gradeLetters[index].letter"
                      ></md-input>
                    </validation-field>
                  </div>
                  <div
                    class="
                      md-layout-item md-size-10
                      flex
                      items-end
                      mb-3
                      text-base
                    "
                  >
                    >=
                  </div>
                  <div class="md-layout-item md-size-45">
                    <validation-field
                      :validations="
                        generateValidation(form.gradeLetters[index], 'score')
                      "
                      :name="'Score ' + (index + 1)"
                    >
                      <md-input
                        :readonly="isReadOnly"
                        v-model.trim="form.gradeLetters[index].score"
                      ></md-input>
                    </validation-field>
                  </div>
                </div>
              </div>
              <div class="md-layout-item md-size-20" v-if="form.isCalculateGpa">
                <validation-field
                  :validations="
                    generateValidation(form.gradeLetters[index], 'gpa')
                  "
                  :name="'GPA value ' + (index + 1)"
                >
                  <md-input
                    :readonly="isReadOnly"
                    v-model.trim="form.gradeLetters[index].gpa"
                  ></md-input>
                </validation-field>
              </div>
              <div
                class="md-layout-item md-size-5 flex items-end justify-center"
                v-if="index >= 7"
                @click="deleteGradeScale(index)"
              >
                <md-icon class="icon-delete">delete</md-icon>
              </div>
            </div>
          </div>
          <!-- list form grade letter -->

          <div class="md-layout flex justify-start my-5 mb-8 pl-3">
            <md-button
              :disabled="isReadOnly"
              @click="addgradeScale"
              class="md-success"
            >
              <i class="fas fa-plus text-sm "></i>
              {{ $t("common.add") }}
            </md-button>
          </div>

          <!-- Grade letter -->
        </md-card-content>
      </md-card>
    </div>

    <slot name="footer-actions"></slot>
    <div class="form-actions text-center">
      <md-button class="md-raised" @click="goToPreviousPage">{{
        $t("common.cancel")
      }}</md-button>
      <md-button
        v-if="isDetailPage && !isReadOnly"
        :disabled="!isDisabled"
        type="submit"
        class="md-success ml-4"
      >
        {{ $t("common.update") }}</md-button
      >
      <md-button
        v-if="!isDetailPage"
        :disabled="!isDisabled"
        type="submit"
        class="md-success ml-4"
      >
        {{ $t("common.add") }}</md-button
      >
    </div>
  </validation-form>
</template>

<script>
import pick from "lodash/pick";
import cloneDeep from "lodash/cloneDeep";
import filter from "lodash/filter";
import { validations } from "@/validations/grade_scale";
import { convertObj, hasHistory } from "@/helpers/utils";
import { GradeScale } from "@/constants/Permissions";

const initGradeLetters = Array.from({ length: 7 }, (v, i) => {
  return {
    // gradeScale1: "",
    // gradeScale2: "",
    gpa: "",
    isPassed: false,
    score: "",
    letter: ""
  };
});

const initFormData = () => ({
  GradeScale,
  name: null,
  description: null,
  scoreToPass: "0.0",
  extraPointHonor: "0.0",
  extraPointAdvanced: "0.0",
  isCalculateGpa: true,
  gradeLetters: initGradeLetters
});

export default {
  name: "main-information",
  props: ["isDetailPage", "gradeScaleData"],
  data() {
    const self = this;
    return {
      GradeScale,
      form: initFormData(),
      defaultForm: initFormData(),
      classId: this.$route.params.id,
      gradeScaleValidations: validations
    };
  },
  computed: {
    isReadOnly() {
      return (
        !this.$can(GradeScale.actions.edit, GradeScale.subject) &&
        this.isDetailPage
      );
    },
    gradeScaleClass() {
      return this.form.isCalculateGpa ? "md-size-55" : "md-size-75";
    },
    isDisabled() {
      return this.form.gradeLetters.find(item => {
        return (
          item.letter.length > 0 || item.score.length > 0 || item.gpa.length > 0
        );
      });
    }
  },
  created() {
    this.clearFormGradeLetter(this.form.gradeLetters);
    if (this.isDetailPage) {
      this.form = convertObj.snakeCaseToCamelCase(this.gradeScaleData);
    }
  },
  methods: {
    onBlur(e) {
      const { value } = e.target;
      this.form.scoreToPass = Number.parseFloat(value).toFixed(1);
    },
    generateValidation(value, field) {
      const isValid = value.letter || value.score || value.gpa;
      if (isValid) {
        return this.gradeScaleValidations[field];
      }
      return {};
    },
    addgradeScale() {
      this.form.gradeLetters = [
        ...this.form.gradeLetters,
        {
          id: this.form.gradeLetters.length,
          letter: "",
          score: "",
          description: "",
          gpa: "",
          isPassed: false
        }
      ];
    },
    deleteGradeScale(index) {
      this.form.gradeLetters.splice(index, 1);
    },
    submitForm() {
      const submittingFormData = this.getSubmitForm();
      this.$emit(
        "on-submit",
        convertObj.camelCaseToSnakeCase(submittingFormData)
      );
    },
    updateForm(classInfo) {
      this.form = pick(classInfo, Object.keys(this.form));
    },

    // clearForm() {
    //   this.updateForm(this.defaultForm);
    // },
    clearFormGradeLetter(gradeLetter) {
      gradeLetter.forEach(item => {
        item = Object.assign(item, {
          letter: "",
          score: "",
          gpa: ""
        });
      });
    },
    getSubmitForm() {
      if (this.form.extraPointHonor === "") {
        this.form.extraPointHonor = "0.0";
      }
      if (this.form.extraPointAdvanced === "") {
        this.form.extraPointAdvanced = "0.0";
      }
      if (this.form.scoreToPass === "") {
        this.form.scoreToPass = "0.0";
      }
      if (!this.form.isCalculateGpa) {
        this.form.gradeLetters.forEach(item => {
          item.gpa = "";
        });
      }
      const formData = cloneDeep(this.form);
      const gradeLetters = filter(formData.gradeLetters, function(gradeScale) {
        return gradeScale.letter || gradeScale.score || gradeScale.gpa;
      });
      formData.gradeLetters = gradeLetters;
      return formData;
    },

    // called when update in detail page
    injectFormData(gradeScaleInfo) {
      const gradeScaleInfoCamelCase = convertObj.snakeCaseToCamelCase(
        gradeScaleInfo
      );
      this.form = gradeScaleInfoCamelCase;
      this.updateForm(gradeScaleInfoCamelCase);

      // // inital default values
      this.defaultForm = pick(classInfo, Object.keys(this.defaultForm));
    },
    goToPreviousPage() {
      hasHistory() ? this.$router.go(-1) : this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
.creating-class-mode {
  padding-bottom: 14px;
}
.icon-delete {
  color: red !important;
  cursor: pointer;
}
.personal-information {
  padding: 0 15px 0 15px;
}
</style>
